import React, { FC } from 'react';
import { Box, EmptyState, Heading, Text, TextButton } from '@wix/design-system';
import { Revert } from '@wix/wix-ui-icons-common';
import { useShallowRouter } from '@components/Hooks/useRouter';
import { updateQueryParams } from '@utils/route';
import { useTranslation } from '@wix/fe-essentials-standalone';
import s from './NoResultsErrorState.module.scss';

type Props = {
  isMobileView?: boolean;
};

const NoResultsErrorState: FC<Props> = ({ isMobileView }) => {
  const { t } = useTranslation();
  const { navigate, router } = useShallowRouter();
  const clearAll = () => {
    navigate(
      updateQueryParams({}, router, {
        all: true,
      }),
      false,
    );
  };

  return (
    <Box
      align="center"
      width="100%"
      height="100%"
      dataHook="templates-no-results-error-state"
    >
      <EmptyState
        theme="page-no-border"
        title={
          <Heading
            className={s.heading}
            size={isMobileView ? 'large' : 'extraLarge'}
          >
            {t('marketplace.template-empty-error-title')}
          </Heading>
        }
        subtitle={
          <Text size={isMobileView ? 'small' : 'medium'}>
            {t('marketplace.template-empty-error-subtitle')}
          </Text>
        }
      >
        {isMobileView && (
          <TextButton onClick={clearAll} prefixIcon={<Revert />}>
            {t('marketplace.template-empty-error-cta')}
          </TextButton>
        )}
      </EmptyState>
    </Box>
  );
};

export default NoResultsErrorState;
